import axios from 'axios';
import { URLBI } from 'baseURL/baseURL';
console.log('url', URLBI);
const baseURL = URLBI;

const app = axios.create({
    baseURL
});

app.interceptors.request.use(
    (config) => {
        return {
            ...config,
            headers: {
                ...config.headers,
                common: {
                    ...config.headers.common,
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }
        };
    },
    (error) => Promise.reject(error)
);

export { app };
